const Faq = () => {
	
    return ( 
        <div>
            <div class="home_faq" id="faq">
				<div class="container">
					<div class="home_faq_max">
						<div class="home_road_map_heading">
							<h3><em>FREQUENTLY  </em> <br/> ASKED QUESTIONS</h3>
						</div>
						<div class="home_faq_flex">
							<div class="home_faq_inner">
								<div class="faq_1  ac-title" data-in="#tab1">
									<h6 class="accordion">Why should I join the Universal Space Station?</h6>
									<div class="panel accordian-para acc-show" id="tab1">
										<p>When you buy a Universal Space Station Crypto Pilot NFT, you’re not just getting an avatar or provably-rare piece of art — you’re gaining membership access to the Universal Space Station Metaverse with many perks like:<br/><br/>
										Ownership and commercial usage rights of their NFT(s).<br/> Endorsement opportunities with brands for Pilot holders.<br/>Enjoy random monthly prizes from 2.5% of the "second-market royalties".<br/> An option for one Free Space Rocket NFT, gas fees apply.<br/> Priority Mint Rights for a "Surprise" NFT.<br/>Whitelist guarantee for future Universal Space Station projects<br/>Whitelist opportunities into popular projects from our partners.<br/>Access to the Universal Space Station Metaverse.</p>
									</div>
								</div>
							</div>
							<div class="home_faq_inner">
								<div class="faq_1  ac-title" data-in="#tab2">
									<h6 class="accordion"> How many Crypto Pilot NFT can I mint?</h6>
									<div class="panel accordian-para acc-show" id="tab2">
										<p>You will be able to mint a maximum of 100 Crypto Pilot NFT per wallet. <br/><br/>There will be a maximum of 10,000 Crypto Pilot NFTs available for mint for the whole project.<br/><br/>Pre-Sale maximum of 5 Crypto Pilot NFT per wallet</p>
									</div>
								</div>
							</div>
							<div class="home_faq_inner">
								<div class="faq_1  ac-title" data-in="#tab3">
									<h6 class="accordion"> Where can I view my NFT?</h6>
									<div class="panel accordian-para acc-show" id="tab3">
										<p>Once minted, the Crypto Pilot NFT  token will be added to your wallet which you can check via the Ethereum blockchain.<br/><br/>You will also be able to view the NFT on OpenSea.io once the listing is approved
										</p>
									</div>
								</div>
							</div>
							<div class="home_faq_inner">
								<div class="faq_1  ac-title" data-in="#tab4">
									<h6 class="accordion">Is there a presale?</h6>
									<div class="panel accordian-para acc-show" id="tab4">
										<p>Yes, there is a presale which you need to win a whitelist entry. <br/><br/>There will be a total of 1000 members who will be able to be whitelisted for presale. To be eligible for the presale check our discord on how to get whitelisted.</p>
									</div>
								</div>
							</div>       
							<div class="home_faq_inner">
								<div class="faq_1  ac-title" data-in="#tab5">
									<h6 class="accordion">What about the Mint price?</h6>
									<div class="panel accordian-para acc-show" id="tab5">
										<p>PreSale is 0.08 ETH + gas fee <br/><br/>Public Sale is 0.10 ETH + gas fee</p>
									</div>
								</div>
							</div>    
							<div class="home_faq_inner">
								<div class="faq_1  ac-title" data-in="#tab6">
									<h6 class="accordion">When will I be able to mint the Crypto Pilot NFT?</h6>
									<div class="panel accordian-para acc-show" id="tab6">
										<p>A specific date for presales and time will be announced at least 7 days before the drop!</p>
									</div>
								</div>
							</div>               
						</div>
					</div>
				</div>
            </div>
        </div>
     );
}
 
export default Faq;



